import { mapActions, mapState } from "vuex";
import _ from "lodash";
// @DEPRECATE: use defaultOptionsDataTable to delegate the options to data table.
export const defaultFilterOptions = () => ({
  groupBy: [],
  groupDesc: [],
  itemsPerPage: 25,
  multiSort: false,
  mustSort: false,
  page: 1,
  sortBy: [],
  sortDesc: []
});
const tabWithFilterObject = 1;
export const CommonPayload = {
  created() {
    this.options =
      this.nameOptionsDataTable == this.$route.name
        ? this.optionsDataTable
        : defaultFilterOptions();
    this.search =
      this.nameOptionsDataTable == this.$route.name &&
      !_.isObject(this.filterDataTable)
        ? this.filterDataTable
        : "";
  },
  computed: {
    ...mapState([
      "optionsDataTable",
      "nameOptionsDataTable",
      "filterDataTable",
      "tabDataTable"
    ])
  },
  methods: {
    ...mapActions(["saveOptionsDataTable"]),
    updateOptionsAccordingTabView(tab) {
      this.options =
        this.tabDataTable == tab ? this.options : defaultFilterOptions();
      // Se a tab utilizar filtro personalizado, então é um objeto e deve-se utilizar o filterDataTable.
      this.search =
        this.tabDataTable == tab && tab == tabWithFilterObject
          ? this.filterDataTable
          : "";
    },
    toLSPFilter(options, filter) {
      const {
        multiSort, // eslint-disable-line no-unused-vars
        mustSort, // eslint-disable-line no-unused-vars
        itemsPerPage: page_size,
        sortDesc,
        sortBy,
        ...rest
      } = options;

      return {
        query: filter,
        page_size,
        direction: sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc",
        sort: sortBy.length == 1 ? sortBy[0] : "",
        ...rest
      };
    },
    toLSPCompanyFilter(options, filter) {
      const { byStatus, byKind, ...rest } = options;

      const byStatusTable = {
        Todos: {},
        Ativos: { somente_ativos: true },
        Inativos: { somente_inativos: true }
      };

      const byKindTable = {
        Todos: {},
        "Tomadores Matriz": { subsidiarias: false },
        "Tomadores Filiais": { tomadores: false },
        "Matrizes": { subsidiarias: false },
        "Filiais": { tomadores: false },
      };

      return this.toLSPFilter(
        {
          ...byStatusTable[byStatus],
          ...byKindTable[byKind],
          ...rest
        },
        filter
      );
    },
    // @DEPRECATE: use toLSPFilter to delegate the query params to axios.
    getPayload(options, filter) {
      // Payload default para tabelas com filtro,
      // paginação e ordenação via back-end
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return `?page=${page}&page_size=${itemsPerPage}&sort=${sort}&direction=${directSort}&query=${filter}`;
    },
    payloadOptions(tab = null) {
      return {
        name: this.$route.name,
        options: this.options,
        filter: this.search || this.quotationFilter,
        tab: tab
      };
    }
  }
};
